import React, { useState, useEffect } from "react";
import { Link } from "gatsby"
import loadable from "@loadable/component"
import { Container, Row, Col } from 'react-bootstrap'
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router";

import "gatsby-theme-starberry-lomondgroup/src/components/LocationBlock/LocationBlock.scss";
import BoxBlock from "gatsby-theme-starberry-lomondgroup/src/components/BoxBlock/Box"
import ContentModule from "gatsby-theme-starberry-lomondgroup/src/modules/content_module";

import { OfficeList, AreaList } from "gatsby-theme-starberry-lomondgroup/src/common/queries/common_use_query"

const Select = loadable(() => import("react-select"));

const Location = ({ Module }) => {
    const location = useLocation();

    const getSearchQueryFromURL = () => {
        const params = new URLSearchParams(location.search);
        return params.get("q") || "";
    };

    const data = useStaticQuery(graphql`
        query OfficeListCustom {
            glstrapi {
                offices(sort: "name:ASC", where:{publish:true}) {
                    id
                    slug
                    name
                    address
                    nearby_postcodes
                    mobile
                    email
                    office_crm_id
                    areas {
                        id
                        area_name
                    }
                    image {
                        url
                        alternativeText
                    }
                    imagetransforms
                    ggfx_results {
                        id
                        content_type
                        transforms
                        src_import_url
                        src_cftle
                        field
                    }
                    sort
                }
            }
        }
    `);
    
    const [office_list, setOfficeList] = useState(data.glstrapi.offices);
    const [filter_area, setFiltArea] = useState(null);
    const [searchArea, setSearchArea] = useState(getSearchQueryFromURL()); // Set initial search value

    const { data: area_data } = AreaList();

    const office_data = data.glstrapi.offices;

    useEffect(() => {
        
        if (office_data && office_data.length > 0) {
            let filtered_offices = [...office_data];

            if (filter_area?.value) {
                filtered_offices = filtered_offices.filter(office =>
                    office.areas.some(area => area.id === filter_area.value)
                );
            }

            if (searchArea) {
                filtered_offices = filtered_offices.filter(office =>
                    office.address.toLowerCase().includes(searchArea.trim().toLowerCase()) ||
                    office.name.toLowerCase().includes(searchArea.trim().toLowerCase()) ||
                    office?.nearby_postcodes?.toLowerCase().includes(searchArea.trim().toLowerCase())
                );
            }

            setOfficeList(filtered_offices);
        }
    }, [filter_area, searchArea, office_data]);

    const options = [{ value: '', label: 'All Locations' }];
    area_data?.areas?.forEach(area => {
        options.push({ value: area.id, label: area.area_name });
    });


    return (
        <React.Fragment>
            <section className="location-block">
                <Container>
                    <Row>
                        <Col>
                            <div className="location-search-box">
                                <input
                                    className="form-control location-search"
                                    placeholder="Search by area or postcode"
                                    value={searchArea}
                                    onChange={(event) => setSearchArea(event.target.value)}
                                />
                                <button className="search-icon">
                                    <i className="icon-search"></i>
                                    <span className="d-none d-xl-flex">Search</span>
                                </button>
                            </div>

                            {Module.description && <ContentModule Content={Module.description} />}

                            <div className="filter-wrapper">
                                <span className="sm-text">
                                    Showing {office_list.length} {office_list.length > 1 ? "branches" : "branch"}
                                    {filter_area ? ` across ${filter_area.label}` : ""}
                                </span>

                                <div className="filter-boxes">
                                    <strong className="filter-box">Filter by:</strong>
                                    <Select 
                                        options={options}
                                        placeholder="All Locations" 
                                        className="react-select"
                                        classNamePrefix="react-select" 
                                        onChange={setFiltArea}                                      
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {office_list.length > 0 ? (
                                <div className="box-wrap">
                                    {office_list.map((item, index) => (
                                        <BoxBlock key={index} BoxList={item} />
                                    ))}
                                </div>
                                )
                                :
                                (
                                    <>
                                        <p>
                                            Sorry, we couldn't find a branch with that search. Our friendly Charters team is just a message or call away! With {office_data.length} offices from Alton to Southsea, we’re here to help. See our branches below to find the closest one.
                                        </p>
                                        <div className="box-wrap">
                                            {office_data.length > 0 && office_data.map((item, index) => (
                                                <BoxBlock key={index} BoxList={item} />
                                            ))}
                                        </div>
                                    </>
                                )
                            }
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Location;
